import {
  createV1Order,
  fetchV1Orders,
  fetchV1Order,
} from "@/services/v1/orderAPIService";

export default {
  state: {
    orders: [],
    order: null,
    orderPageSize: 5,
    totalOrderCount: 0,
  },
  getters: {
    orders: (state) => state.orders,
    order: (state) => state.order,
    currentOrderPageSize: (state) => state.orderPageSize,
    totalOrderCount: (state) => state.totalOrderCount,
  },
  mutations: {
    SET_ORDERS(state, orders) {
      state.orders = orders;
    },
    SET_ORDER(state, order) {
      state.order = order;
    },
    SET_ORDER_PAGE_SIZE(state, pageSize) {
      state.orderPageSize = pageSize;
    },
    SET_TOTAL_ORDER_COUNT(state, count) {
      state.totalOrderCount = count;
    },
  },
  actions: {
    async fetchOrders(
      { commit },
      { page = 1, pageSize = 5, customer = null } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Orders(page, pageSize, customer);
        commit("SET_ORDERS", response.results);
        commit("SET_ORDER_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_ORDER_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async fetchOrder({ commit }, orderCode) {
      try {
        const response = await fetchV1Order(orderCode);
        commit("SET_ORDER", response);
      } catch (error) {
        console.error("Error fetching order:", error);
      } finally {
        console.log("finally...");
      }
    },
    async addOrder({ commit }, order) {
      try {
        const response = await createV1Order(order);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`order create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message = error.response?.data?.message || "Failed to add order.";
        return { success: false, message };
      }
    },
  },
};
